<script setup lang="ts">
import CreateHubDialog from '@/modules/Workspaces/KnowledgeHub/Hubs/CreateHubDialog.vue'
import HubsListEmptyStateIllustration from '@/modules/Workspaces/KnowledgeHub/Hubs/HubsListEmptyStateIllustration.vue'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import { ref } from 'vue'

const isHubCreationDialogOpen = ref(false)
</script>

<template>
  <div class="flex flex-col items-center lg:justify-center">
    <div class="grid grid-cols-1 gap-10 lg:grid-cols-2">
      <HubsListEmptyStateIllustration />

      <div class="flex flex-col justify-center gap-6 justify-self-center lg:justify-self-start">
        <h1 class="text-display-sm-24px-default leading-7">
          From messy data to reusable knowledge
          <span class="block text-text-subtlest"> Index and organize your data sources </span>
        </h1>

        <div class="flex max-w-[400px] flex-col gap-2 text-sm-12px-light text-text-subtle">
          <p>
            Hubs index your data based on the provided description, transforming scattered
            information into organized, searchable knowledge.
          </p>
          <p>
            Once indexed, you can search and interrogate your hubs within cases to get better, more
            contextual answers.
          </p>
          <p>Data added through Hubs is never used for model training.</p>
        </div>
        <div>
          <DarwinButton
            rounded
            size="md"
            variant="black"
            @click="isHubCreationDialogOpen = true"
          >
            Create a Hub
          </DarwinButton>
          <CreateHubDialog v-model="isHubCreationDialogOpen" />
        </div>
      </div>
    </div>
  </div>
</template>
